import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { dispatch as StateManagerDispatch } from '../../store/state/state-manager';
import { postProcess, removeContainerItem, addMessages } from '../../store/state/actions/action-creators';
import { ActionManagerInstance } from '../../actions/manager';
import constants, { publicConstants } from '../../constants';
import { CONTAINER_NAMES } from '../../container/container-utils';
import { getParentContextName } from '../../utils/context-utils';
import type { Action } from '../../store/state/state-manager';

import { executeSubmitBulkActionAsyncRequest } from './async-request';
import { publishBulkActionSubmitEvent } from './events';
import { SUBMIT_BULK_ACTION_ASYNC } from './action-creator';

// Todo : Enhance after integrating with actual dxapi
export const submitBulkActionAsync = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: Action[] = [];
  let actionInPayload: Action['payload'];
  let toastMessage = '';

  return action$.pipe(
    ofType(SUBMIT_BULK_ACTION_ASYNC),
    switchMap((action: Action) => {
      const { isFormValid } = action.payload;
      ({ actionMgrID } = action.payload);

      if (!isFormValid) {
        const error = { type: publicConstants.SUBMISSION_FAILURE_TYPE.FORM_VALIDATION_ERROR };
        ActionManagerInstance.rejectActionByID(actionMgrID, true, error);
        // return empty observable as form is not valid.
        return of([]);
      }
      return of(action.payload).pipe(
        switchMap((payload) => {
          actionInPayload = payload;
          return executeSubmitBulkActionAsyncRequest(actionInPayload);
        }),
        map((chainedData) => {
          const errorDetails: { ID: string; message: string }[] = [];
          const { containerItemID, context } = actionInPayload;

          const { response } = chainedData;
          const failureCount = Number(response.failureCount) || 0;

          if (failureCount > 0) {
            response.results.forEach(
              ({
                status,
                error,
                BusinessID
              }: {
                status: string;
                error?: { errorDetails: { localizedValue: string }[] };
                BusinessID: string;
              }) => {
                if (status !== '200' && error && error.errorDetails) {
                  error.errorDetails.forEach(({ localizedValue }) => {
                    errorDetails.push({ ID: BusinessID, message: localizedValue });
                  });
                }
              }
            );
          }
          toastMessage = 'Processing bulk actions, please refresh to check completion';
          publishBulkActionSubmitEvent({ submitResponse: response });
          actionInPayload.target = `${constants.APP.APP}/${CONTAINER_NAMES.MODAL}`;
          actionsOut.push(
            postProcess(removeContainerItem, {
              containerItemID,
              context,
              target: actionInPayload.target,
              skipReleaseLockRequest: true
            })
          );
          if (failureCount) {
            actionsOut.push(
              postProcess(addMessages, {
                messages: [
                  {
                    type: 'error',
                    message:
                      failureCount === 1 ? '1 record failed to update' : `${failureCount} records failed to update`,
                    errorDetails,
                    showHeader: false
                  }
                ],
                context: getParentContextName(context) || context,
                category: 'HTTP',
                showHeader: false
              })
            );
          }
          return actionsOut;
        }),
        map(() => {
          ActionManagerInstance.resolveActionByID(actionMgrID, toastMessage);
          StateManagerDispatch(actionsOut);
          actionsOut = [];
          return actionsOut;
        })
      );
    })
  );
};

export default submitBulkActionAsync;
